/**
 * Shared helpers for the CatalogueEditor + ValidationSidebar.
 *
 * Kept separate from CapabilityCard.jsx so the file can export only
 * components (react-refresh constraint).
 *
 * Phase 44.5.
 */

export function hasTodo(value) {
  if (typeof value !== "string") return false;
  return value === "TODO" || value.startsWith("TODO:");
}

export function capabilityStatus(cap) {
  if (!cap?.name?.trim()) return "empty";
  const fields = [
    cap.what_it_does,
    ...(cap.problems_solved || []),
    ...(cap.replaces || []),
    ...(cap.reduces || []),
    ...(cap.partners_with || []),
    ...(cap.example_competitors || []),
    ...(cap.target_personas || []),
  ];
  if (fields.some(hasTodo) || cap.effort === "TODO" || cap.value_return === "TODO") {
    return "todo";
  }
  if (fields.some((f) => typeof f === "string" && f.trim())) return "complete";
  return "empty";
}
